export * from './DepartmentsList';
